import permissions from '../../extensions/registry/ws-image/constants/permissions';
import handleClipboardPermissionDenied from '../../extensions/registry/ws-image/helpers/handle-clipboard-permission-denied';

const getBlockDataFromClipboard = async () => {
  const { status } = await handleClipboardPermissionDenied(
    permissions.features.CLIPBOARD_READ,
    false
  );

  if (status === permissions.statuses.DENIED) {
    return null;
  }

  let clipboardContent;

  try {
    clipboardContent = await navigator.clipboard.read();
  } catch (e) {
    console.error(e);
    return null;
  }

  if (clipboardContent.length === 0) {
    return null;
  }

  const [clipboardItem] = clipboardContent;

  if (!clipboardItem.types.includes('text/plain')) {
    return null;
  }

  const blob = await clipboardItem.getType(clipboardItem.types[0]);
  const text = await blob.text();

  let parsedData;

  try {
    parsedData = JSON.parse(text);
  } catch (e) {
    return null;
  }

  const blockElement = new DOMParser()
    .parseFromString(parsedData?.blockElement, 'text/html')
    .querySelector('ws-block');

  if (!blockElement) return null;

  return { blockElement, parsedData };
};

export default getBlockDataFromClipboard;
